<template>
    <div class=""></div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            url: {
                type: String,
                default: '',
            },
            method: {
                type: String,
                default: 'get'
            },
            defaultDataToSend: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            responseStatus() {
                if( !this.response ) {
                    return null;
                }
                return this.response.status;
            },
            reponseBody() {
                if( !this.response ) {
                    return null;
                }
                return this.response.data;
            },
            responseData() {
                if( !this.reponseBody ) {
                    return null;
                }
                return this.reponseBody.data;
            }
        },
        data() {
            return {
                response: null,
                ajaxError: null,
                dataToSend: { ...this.defaultDataToSend },

                ajaxLoading: false
            };
        },
        mounted() {

        },
        methods: {
            async callAjax( data = {}, url = this.url, method = this.method ) {
                const { dataToSend } = this;

                return new Promise(( resolve, reject ) => {
                    this.ajaxLoading = true;

                    axios({
                        url,
                        method,

                        [ this.method === 'get' ? 'params' : 'data']: { ...dataToSend, ...data },
                    })
                        .then(( response ) => {
                            this.ajaxError = null;

                            this.ajaxLoading = false;

                            resolve( this.response = response );
                        })
                        .catch(( error ) => {
                            const { response = {} } = error;

                            this.ajaxError = error;

                            this.ajaxLoading = false;

                            resolve( this.response = response );
                        })
                    ;

                });
            }
        }
    }
</script>
